import React from 'react';

// Round progress dots: ● filled, ○ empty
export const IntervalIndicator = ({ total = 8, current = 1, color = '#38BDF8' }) => {
  return (
    <div
      className="flex flex-wrap items-center justify-center gap-2"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-label={`Round ${current} of ${total}`}
    >
      {Array.from({ length: total }).map((_, i) => {
        const active = i < current;
        return (
          <span
            key={i}
            className="rounded-full transition-all duration-300"
            style={{
              width: active ? 14 : 10,
              height: active ? 14 : 10,
              background: active ? color : 'rgba(255,255,255,0.25)',
              boxShadow: active ? `0 0 10px ${color}` : 'none',
            }}
          />
        );
      })}
    </div>
  );
};

export default IntervalIndicator;
